import React from "react";
import {PageLayout} from "../../components/layout/Page/PageLayout.jsx";
import LoginForm from "./components/LoginForm.jsx";
import {GridContainerFlex} from "../../components/layout/GridFlex/GridContainerFlex/GridContainerFlex.jsx";
import {GridItemFlex} from "../../components/layout/GridFlex/GridItemFlex/GridItemFlex.jsx";

export const Login = (props) => {

    return (
        <PageLayout>
            <GridContainerFlex alignItems={"center"} justifyContent={"center"} style={{height: "100vh"}}>
                <GridItemFlex xs={12} sm={6} md={3}>
                    <LoginForm />
                </GridItemFlex>
            </GridContainerFlex>
        </PageLayout>
    )
}